import type { LanguageCodeEnum } from '@/graphql/saleor/api';
import { useGwpDetailsQuery } from '@/graphql/saleor/api';

export const useFetchGwpName = (
  languageCode: LanguageCodeEnum,
  id?: string,
  productType?: string,
  channel?: string,
  name?: string,
) => {
  const shouldFetch = productType === 'gift' && !!channel && !!id;

  const { data } = useGwpDetailsQuery({
    variables: {
      channel: channel as string,
      id: id as string,
      languageCode,
    },
    skip: !shouldFetch,
  });

  return (
    data?.product?.attribute?.values[0]?.translation?.plainText ?? name ?? ''
  );
};
